import { useEffect } from 'react'
import { useRouter } from 'next/router'
import api from '../services/api'
import { useAuth } from './AuthProvider'

const AxiosInterceptor = ({ children }: { children: any }) => {
  const router = useRouter()
  const { logout } = useAuth()

  useEffect(() => {
    const resInterceptor = (response: any) => {
      return response
    }

    const errInterceptor = async (error: any) => {
      const isLogoutRequest = error?.config?.url?.includes('/v1/auth/logout')

      if (error?.response?.status === 401 && !isLogoutRequest) {
        await logout()
      }

      return Promise.reject(error)
    }

    const interceptor = api.interceptors.response.use(
      resInterceptor,
      errInterceptor,
    )

    return () => api.interceptors.response.eject(interceptor)
  }, [router, logout])

  return children
}

export default AxiosInterceptor
